import React, { useState } from 'react';

const ExpandableCell = ({ text, truncateLength  }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isTruncated = text.length > truncateLength;
  const displayText = expanded || !isTruncated ? text : text.slice(0, truncateLength) + "...";
  const tooltipText = isTruncated  ? expanded ? "Click to collapse" : "Click to expand" : "";

  return (
    <span
      onClick={() => isTruncated && setExpanded(prev => !prev)}
      style={{ cursor: isTruncated ? "pointer" : "default" }}
      title={tooltipText}
    >
        <div dangerouslySetInnerHTML={{ __html: displayText }} />
    
    </span>
  );
};

export default ExpandableCell;
